<script setup>
import { useContextStore } from "@/store/context";
import { usePanierStore } from "@/store/panier";

const props = defineProps({
  selectedProduct: {
    type: Object,
    required: true
  }
});

const { layout } = storeToRefs(useContextStore());
const { getStatusObjectifAvantage, isLoading } = storeToRefs(usePanierStore());

const emit = defineEmits(["closed"]);

const popup = computed(() => {
  return defineAsyncComponent(
    lazyComponents[`/components/organisms/popup-lot/${layout.value}.vue`]
  );
});

const getFirstAdvantage = computed(() => {
  return props.selectedProduct.attributes?.avantages?.find(
    (avantage) =>
      avantage?.lot === 2 || (avantage?.lot === 1 && avantage?.nb_pdt_lot > 1)
  );
});

const inCartProduct = computed(() => {
  return getStatusObjectifAvantage.value(getFirstAdvantage.value);
});

const remainProductForOffer = computed(() => {
  return (
    getFirstAdvantage.value?.nb_pdt_lot -
    (inCartProduct.value % getFirstAdvantage.value?.nb_pdt_lot)
  );
});

watch(
  () => inCartProduct.value,
  () => {
    clearAndReload();
  }
);

const clearAndReload = () => {
  clearTimeout(autoDestroy);
  autoDestroy = setTimeout(() => {
    emit("closed");
  }, 3500);
};

let autoDestroy;

onBeforeMount(async () => {
  autoDestroy = setTimeout(() => {
    emit("closed");
  }, 3500);
});

onUnmounted(() => {
  clearTimeout(autoDestroy);
});
</script>

<template>
  <component
    :is="popup"
    v-if="!isLoading"
    :remain-product="remainProductForOffer"
    :in-cart="inCartProduct"
    :total-product="getFirstAdvantage?.nb_pdt_lot"
    :is-fidelite="getFirstAdvantage?.type_avantage === 'EC'"
  />
</template>